import { useTranslation } from 'react-i18next'
import { UnitLabel } from '@/shared/config/config'
import { isValidDecimal, NumericInputGroup } from '@/common'

export default function MassBalanceCalculatorForm({
  quantity,
  carbonContent,
  onQuantityChange,
  onCarbonContentChange
}: {
  quantity: string
  carbonContent: string
  onQuantityChange: (quantity: string) => void
  onCarbonContentChange: (carbonContent: string) => void
}) {
  const { t } = useTranslation()
  return (
    <div className="space-y-4">
      <NumericInputGroup
        label={t('report:calculators.massBalanceCalculatorForm.fields.quantity.label')}
        suffix={UnitLabel.t}
        value={quantity}
        numericFormat={{
          allowNegative: false,
          thousandSeparator: ',',
          // Using the special `onValueChange` prop from the react-number-format library
          // to have access to the value without the thousand separators
          onValueChange: ({ value }) => {
            onQuantityChange(value)
          }
        }}
      />
      <NumericInputGroup
        suffix={UnitLabel.tCarbonPerT}
        label={t('report:calculators.massBalanceCalculatorForm.fields.carbonContent.label')}
        numericFormat={{
          decimalScale: 5,
          allowNegative: false,
          isAllowed: isValidDecimal
        }}
        value={carbonContent}
        onChange={evt => onCarbonContentChange(evt.target.value)}
      />
    </div>
  )
}
